// ═══ 공통 포맷 유틸 — 만원/원 변환 + 천단위 콤마 + 파일명 sanitize ═══
// 모든 파일에서 *10000, /10000, .toLocaleString()+'원' 패턴 통합

// 만원 → 원 변환
var wonFromMan = function(v) {
  return (Number(v) || 0) * 10000;
};

// 원 → 만원 변환 (반올림)
var manFromWon = function(v) {
  return Math.round((Number(v) || 0) / 10000);
};

// 원 단위 천단위 콤마 + '원'
var formatWon = function(v) {
  return (Number(v) || 0).toLocaleString() + '원';
};

// 만원 단위로 표시 ('1,234만원')
var formatMan = function(v) {
  return manFromWon(v).toLocaleString() + '만원';
};

// 파일명에 사용 불가한 문자 제거 (Windows/macOS 공통)
var sanitizeFilename = function(str) {
  return (str || '').replace(/[\\/:*?"<>|]/g, '_');
};

export { wonFromMan, manFromWon, formatWon, formatMan, sanitizeFilename };
